export const FORM_DEFAULT_VALUES = {
  issueTitle: '',
};

export const ISSUE_TITLE = 'issueTitle';
